<template>
  <div>
    <div id="section-to-print">
      <v-row type="flex" class="row-bg fTitle" style="padding-right: 20px;">
        <v-spacer></v-spacer>
        ទម្រង់បញ្ជាទិញ
      </v-row>
      <hr style="border-top: 3px solid green;">
      <table>

        <tr v-if="isOperator">
          <td colspan="6">
            ឈ្មោះអ្នកផ្គត់ផ្គង់៖ {{ poDoc.supplier_name }}
          </td>
          <td colspan="3">
            លេខទូរស័ព្ទ៖ {{ poDoc.supplier_mobile | formatPhoneNumber }}
          </td>
        </tr>

        <tr v-if="isOperator">
          <td>អាស័យដ្ឋាន៖</td>
          <td colspan="2">ភូមិ {{ poDoc.supplier_village_name }}</td>
          <td colspan="2">ឃុំ {{ poDoc.supplier_communce_name }}</td>
          <td colspan="2">ស្រុក {{ poDoc.supplier_district_name }}</td>
          <td colspan="2">ខេត្ត {{ poDoc.supplier_province_name }}</td>
        </tr>

        <tr>
          <td colspan="6">
            ឈ្មោះអតិថិជន៖ {{ poDoc.client_name }}
          </td>
          <td colspan="3">
            លេខទូរស័ព្ទ៖ {{ poDoc.client_phone | formatPhoneNumber }}
          </td>
        </tr>

        <tr>
          <td>អាស័យដ្ឋាន៖</td>
          <td colspan="2">ភូមិ {{ poDoc.client_village_name }}</td>
          <td colspan="2">ឃុំ {{ poDoc.client_communce_name }}</td>
          <td colspan="2">ស្រុក {{ poDoc.client_district_name }}</td>
          <td colspan="2">ខេត្ត {{ poDoc.client_province_name }}</td>
        </tr>
        <tr>
          <td>ប្រភេទអតិថិជន៖</td>
          <td colspan="2">
            <v-checkbox hide-details style="margin-top: 0px !important;padding-top: 0px !important;"
                        :value="poDoc.client_type==='beedepo'" label="ប៊ីដេប៉ូ" readonly
            ></v-checkbox>
          </td>
          <td colspan="2">
            <v-checkbox hide-details style="margin-top: 0px !important;padding-top: 0px !important;"
                        :value="poDoc.client_type==='beeshop'" label="ប៊ីសប" readonly
            ></v-checkbox>
          </td>
          <td colspan="2">
            <v-checkbox hide-details style="margin-top: 0px !important;padding-top: 0px !important;"
                        :value="poDoc.client_type==='beexpress'" label="ប៊ីអ៊ិចប្រេស" readonly
            ></v-checkbox>
          </td>
          <td colspan="2">កាលបរិច្ឆេទ៖ {{ poDoc.date }}</td>
        </tr>
        <tr>
          <td colspan="7"></td>
          <td colspan="2">លេខទម្រង់បញ្ជាទិញ៖ {{ poDoc.reference }}</td>
        </tr>
      </table>

      <table class="border">
        <thead>
        <tr>
          <th>ល.រ</th>
          <th>ឈ្មោះទំនិញ</th>
          <th>ឯកតា</th>
          <th>បរិមាណ</th>
          <th>តម្លៃរាយ</th>
          <th>តម្លៃសរុប</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(d ,ind) in poDoc.transaction_order_line" :key="ind">
          <td style="text-align: center">{{ ind + 1 }}</td>
          <td>{{ d.name }}</td>
          <td style="text-align: center">{{ d.unit_name }}</td>
          <td style="text-align: center">{{ parseFloat(d.order_qty) }}</td>
          <td style="text-align: right">{{ parseFloat(d.price) | formatNumber }}{{ d.currency_symbol }}</td>
          <td style="text-align: right">{{
              parseFloat(d.price) * parseFloat(d.order_qty) | formatNumber
            }}{{ d.currency_symbol }}
          </td>
        </tr>

        <tr>
          <th colspan="4" style="text-align: right">សរុប</th>
          <td colspan="2" style="text-align: right">
            {{ parseFloat(poDoc.total_amount) | formatNumber }}{{ getCurrencySymbol(poDoc.currency_code) }}
          </td>
        </tr>
        </tbody>
      </table>
      <table>
        <tr>
          <td>ពិនិត្យដោយ</td>
          <td style="text-align: center">ស្នាមមេដៃអ្នកបញ្ជាទិញ</td>
        </tr>
        <tr>
          <td style="padding-top: 10px;padding-bottom: 10px">
            {{ poDoc.operator_name }}
          </td>
        </tr>
        <tr>
          <td colspan="2">មន្ត្រីប្រតិបត្តិការមូលដ្ឋាន ៖</td>
        </tr>
        <tr>
          <td>កាលបរិច្ឆេទ ៖ ...............................</td>
        </tr>


      </table>
      <div class="footer-right">
        <p>Instant DN Form-V0 {{ today }}</p>
      </div>
    </div>


  </div>

</template>

<script>

import {provider} from "@/service/provider";
import axios from "axios";
import MainMixin from "../../../mixins/mainMixin"
import moment from "moment";

export default {
  mixins: [MainMixin],
  data() {
    return {
      valid: false,
      loadingReport: false,
      params: {
        dateRange: [],
      },
      poDoc: {},
      today:moment().format("YYYYMMDD")

    }
  },
  methods: {
    handlePrint(event) {
      event.preventDefault();
      window.print();
    },
    handleRun(id) {
      let vm = this;
      vm.loadingReport = true;

      let url = provider.baseURL + provider.getTransactionOrder;
      return new Promise((resolve, reject) => {
        axios.post(url, {
          search: "",
          id: id,
          contact_id: "",
          offset: 0,
          type_order:"",
          sort_by: "",
          sort_desc: 0,
          limit: 1,
          from_date:'',
          to_date: ''
        }, {headers: {Authorization: localStorage.token}}).then(
            res => {
              if (res.data.response && res.data.response.code === 200) {
                resolve(res.data.data);

                let newItem = res.data.data[0];
                vm.poDoc = Object.assign({}, newItem);
                vm.poDoc.total_amount = parseFloat(vm.poDoc.total_amount);
                vm.poDoc.transaction_order_line.map((d) => {
                  d.currency_code = vm.poDoc.currency_code;
                  d.currency_symbol = vm.getCurrencySymbol(d.currency_code);
                  d.order_qty = parseFloat(d.order_qty);
                  /*d.ab_fee = parseFloat(d.ab_fee);
                  d.cost = parseFloat(d.cost);
                  d.margin = parseFloat(d.margin);*/
                  d.price = parseFloat(d.price);
                  d.total_amount = parseFloat(d.total_amount);
                  return d;
                })

                vm.$nextTick(() => {
                  window.print();
                  vm.$router.push({name:"beeshop.agri-input.order-management.order"});
                })
              }
            },
            error => {
              reject(error);
            }
        );
      })

    }
  },
  watch: {},
  created() {
    let vm = this;
    let id = vm.$route.params.id;
    if (id) {
      setTimeout(function () {
        vm.handleRun(id);
      }, 300)
    }
  }
}
</script>